import { createContext } from 'react';

export type Space = {
  id: string;
  name: string;
  slug: string;
};

export type SpaceMembership = {
  space: Space;
  role: 'admin' | 'board_member' | 'reader';
};

export interface SpaceContextType {
  currentSpace: Space | null;
  memberships: SpaceMembership[];
  isSuperAdmin: boolean;
  isLoading: boolean;
  switchSpace: (slug: string) => void;
}

export const SpaceContext = createContext<SpaceContextType | undefined>(undefined);
